'use client'

import { useState } from 'react'
import type { SearchResult } from '@/types/dictionary'

const HISTORY_KEY = 'dict_history'
const MAX_HISTORY = 20

export function useHistory() {
  const [history, setHistory] = useState<SearchResult[]>(() => {
    // SSR-safe: only access localStorage in the browser
    if (typeof window === 'undefined') {
      return []
    }
    try {
      const stored = localStorage.getItem(HISTORY_KEY)
      return stored ? JSON.parse(stored) : []
    } catch {
      return []
    }
  })

  const addToHistory = (item: SearchResult) => {
    setHistory((prev) => {
      // Remove duplicates (move to top)
      const filtered = prev.filter((h) => h.id !== item.id)
      const newHistory = [item, ...filtered].slice(0, MAX_HISTORY)
      // SSR-safe: only access localStorage in the browser
      if (typeof window !== 'undefined') {
        localStorage.setItem(HISTORY_KEY, JSON.stringify(newHistory))
      }
      return newHistory
    })
  }

  const clearHistory = () => {
    // SSR-safe: only access localStorage in the browser
    if (typeof window !== 'undefined') {
      localStorage.removeItem(HISTORY_KEY)
    }
    setHistory([])
  }

  return { history, addToHistory, clearHistory }
}
